import * as Yup from 'yup';

const requiredField = 'Required';

export const PatienDetailSchema = Yup.object().shape({
  patientName: Yup.string().required(requiredField),
  patientNric: Yup.string().required(requiredField),
  patientGender: Yup.string().required(requiredField),
  patientDob: Yup.string().required(requiredField),
});

export const MemoContentSchema = Yup.object().shape({
  subject: Yup.string().required(requiredField),
  content: Yup.string().required(requiredField),
});

export const ReferralFormSchema = Yup.lazy(values => {
  const { referToManaDr } = values;
  return referToManaDr
    ? Yup.object().shape({
        // fromClinicId: Yup.string().required(requiredField),
        toDoctorId: Yup.string().required(requiredField),
      })
    : Yup.object().shape({
        // fromClinicId: Yup.string().required(requiredField),
        specialistInfo: Yup.string().trim().required(requiredField),
        specialistEmail: Yup.string().email('Invalid email').nullable(),
      });
});
